/* Soothefy landing — shared behavior */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Header: mobile menu + cart count ---------- */
  function initHeader(root) {
    var burger = $('[data-sf-burger]', root);
    var menu = $('[data-sf-menu]', root);
    if (burger && menu && !burger.dataset.sfInit) {
      burger.dataset.sfInit = '1';
      burger.addEventListener('click', function () { menu.classList.add('is-open'); });
      $$('[data-sf-menu-close], .sf-menu__scrim, .sf-menu__panel nav a', menu).forEach(function (el) {
        el.addEventListener('click', function () { menu.classList.remove('is-open'); });
      });
    }
  }

  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-sf-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
    }).catch(function () {});
  }

  /* ---------- Lazy video queue (max 2 concurrent, nearest first) ---------- */
  var vidTimer = null;
  function checkVideos() {
    var vh = window.innerHeight || 0;
    var vids = $$('video[data-sf-lazy]');
    if (!vids.length) return;
    vids.forEach(function (v) {
      if (v.getAttribute('src')) {
        var r = v.getBoundingClientRect();
        var visible = r.bottom > 0 && r.top < vh;
        if (visible) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (!v.paused) { v.pause(); }
      }
    });
    var now = Date.now();
    var loading = vids.filter(function (v) { return v.getAttribute('src') && v.readyState < 2 && now - (Number(v.dataset.loadStart) || 0) < 8000; }).length;
    var budget = 2 - loading;
    if (budget <= 0) return;
    vids
      .filter(function (v) { return !v.getAttribute('src') && v.dataset.src; })
      .map(function (v) {
        var r = v.getBoundingClientRect();
        return { v: v, near: r.bottom > -600 && r.top < vh + 600, dist: Math.abs((r.top + r.bottom) / 2 - vh / 2) };
      })
      .filter(function (x) { return x.near; })
      .sort(function (a, b) { return a.dist - b.dist; })
      .slice(0, budget)
      .forEach(function (x) {
        var v = x.v;
        v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
        v.dataset.loadStart = String(Date.now());
        v.src = v.dataset.src;
        var kick = function () { checkVideos(); };
        var hidePoster = function () {
          var p = v.parentElement && v.parentElement.querySelector('[data-sf-vposter]');
          if (p) p.style.opacity = '0';
        };
        v.addEventListener('loadeddata', hidePoster, { once: true });
        v.addEventListener('loadeddata', kick, { once: true });
        v.addEventListener('canplaythrough', kick, { once: true });
        v.addEventListener('error', kick, { once: true });
        if (v.readyState >= 2) hidePoster();
      });
  }

  /* ---------- Buy box ---------- */
  function initBuyBox(section) {
    if (!section || section.dataset.sfInit) return;
    section.dataset.sfInit = '1';
    var dataEl = $('[data-sf-variants]', section);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var state = {
      bundle: section.dataset.defaultBundle || 'system',
      single: variants[0] ? variants[0].id : null,
      slots: [],
      view: ''
    };
    var bundleQty = Number(section.dataset.bundleQty || 3);
    for (var i = 0; i < bundleQty; i++) state.slots.push(variants[i % variants.length] ? variants[i % variants.length].id : null);
    if (variants[1]) state.slots[bundleQty - 1] = variants[1].id; // default mix

    function vById(id) { return variants.filter(function (v) { return v.id === id; })[0] || variants[0]; }
    function colorOf(v) { return (v && v.title ? v.title : '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    state.view = colorOf(variants[0]);

    /* Gallery color filter: only the images of the color being viewed (last-tapped swatch) show; untagged images always show */
    function applyColorFilter() {
      var view = state.view;
      var thumbs = $$('.sf-thumb', section);
      imgs.forEach(function (im, ix) {
        var c = im.dataset.sfColor || '';
        var ok = !c || c === view;
        im.dataset.sfHidden = ok ? '0' : '1';
        if (thumbs[ix]) thumbs[ix].style.display = ok ? '' : 'none';
      });
      if (imgs[gi] && imgs[gi].dataset.sfHidden === '1') {
        for (var ix = 0; ix < imgs.length; ix++) {
          if (imgs[ix].dataset.sfHidden !== '1') { showImg(ix); break; }
        }
      }
    }

    function render() {
      var isSystem = state.bundle === 'system';
      $$('[data-sf-bundle]', section).forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.sfBundle === state.bundle);
      });
      var slotsWrap = $('[data-sf-slots]', section);
      var singleWrap = $('[data-sf-single-colors]', section);
      if (slotsWrap) slotsWrap.style.display = isSystem ? '' : 'none';
      if (singleWrap) singleWrap.style.display = isSystem ? 'none' : '';
      $$('[data-sf-slot]', section).forEach(function (row) {
        var idx = Number(row.dataset.sfSlot);
        $$('.sf-swatch', row).forEach(function (sw) {
          sw.classList.toggle('is-active', Number(sw.dataset.variant) === state.slots[idx]);
        });
      });
      $$('[data-sf-single-colors] .sf-swatch', section).forEach(function (sw) {
        sw.classList.toggle('is-active', Number(sw.dataset.variant) === state.single);
      });
      var offer = $('[data-sf-offerline]', section);
      if (offer) offer.textContent = isSystem ? offer.dataset.system : offer.dataset.single;
      applyColorFilter();
    }

    section.addEventListener('click', function (e) {
      var bundleBtn = e.target.closest('[data-sf-bundle]');
      if (bundleBtn) { state.bundle = bundleBtn.dataset.sfBundle; render(); return; }
      var sw = e.target.closest('.sf-swatch[data-variant]');
      if (sw) {
        var slotRow = sw.closest('[data-sf-slot]');
        var id = Number(sw.dataset.variant);
        if (slotRow) { state.slots[Number(slotRow.dataset.sfSlot)] = id; }
        else { state.single = id; }
        state.view = colorOf(vById(id));
        render();
        showVariantImage(id);
        return;
      }
    });

    /* Gallery */
    var imgs = $$('[data-sf-gallery] img', section);
    var gi = 0;
    function showImg(n) {
      gi = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, ix) { im.classList.toggle('is-active', ix === gi); });
      $$('.sf-thumb', section).forEach(function (t, ix) { t.classList.toggle('is-active', ix === gi); });
      var row = $('[data-sf-thumbs]', section);
      var btn = $$('.sf-thumb', section)[gi];
      if (row && btn) {
        var left = btn.offsetLeft - row.offsetLeft;
        var right = left + btn.offsetWidth;
        if (left < row.scrollLeft + 8) row.scrollTo({ left: Math.max(0, left - 12), behavior: 'smooth' });
        else if (right > row.scrollLeft + row.clientWidth - 8) row.scrollTo({ left: right - row.clientWidth + 12, behavior: 'smooth' });
      }
    }
    function stepImg(dir) {
      if (!imgs.length) return;
      var n = gi;
      for (var k = 0; k < imgs.length; k++) {
        n = (n + dir + imgs.length) % imgs.length;
        if (imgs[n].dataset.sfHidden !== '1') break;
      }
      showImg(n);
    }
    function showVariantImage(id) {
      var v = vById(id);
      if (!v) return;
      var done = false;
      if (v.image) {
        imgs.forEach(function (im, ix) {
          if (!done && im.getAttribute('src') && im.getAttribute('src').split('?')[0] === v.image.split('?')[0]) { showImg(ix); done = true; }
        });
      }
      if (!done) {
        var c = colorOf(v);
        if (c) {
          imgs.forEach(function (im, ix) {
            if (!done && im.dataset.sfColor === c) { showImg(ix); done = true; }
          });
        }
      }
    }
    $$('[data-sf-arrow]', section).forEach(function (a) {
      a.addEventListener('click', function () { stepImg(Number(a.dataset.sfArrow)); });
    });
    $$('.sf-thumb', section).forEach(function (t, ix) {
      t.addEventListener('click', function () { showImg(ix); });
    });
    var row = $('[data-sf-thumbs]', section);
    if (row) {
      var drag = null;
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        e.preventDefault();
        row.style.scrollBehavior = 'auto';
        drag = { x: e.clientX, left: row.scrollLeft, moved: false };
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        e.preventDefault();
        var dx = e.clientX - drag.x;
        if (Math.abs(dx) > 6) drag.moved = true;
        row.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (drag) row.style.scrollBehavior = '';
        if (drag && drag.moved) {
          var stop = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
          document.addEventListener('click', stop, { capture: true, once: true });
        }
        drag = null;
      });
    }

    /* Add to cart — stays on the page. Posts JSON: Shopify's shop_events_listener can only
       parse JSON bodies, and it must see the request to publish the product_added_to_cart
       analytics event (a form-encoded body adds to cart fine but the add goes untracked).
       Falls back to the form-encoded post if the JSON request is rejected. */
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    function readErr(r) {
      return r.json().catch(function () { return {}; }).then(function (body) {
        throw new Error((body && (body.description || body.message)) || ('HTTP ' + r.status));
      });
    }
    function postForm(items) {
      var params = new URLSearchParams();
      items.forEach(function (it, i) {
        params.append('items[' + i + '][id]', it.id);
        params.append('items[' + i + '][quantity]', it.quantity);
      });
      params.append('sections', '');
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: params.toString()
      });
    }
    function postJson(items) {
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });
    }
    var atc = $('[data-sf-atc]', section);
    if (atc) atc.addEventListener('click', function () {
      var items = [];
      if (state.bundle === 'system') {
        var counts = {};
        state.slots.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        Object.keys(counts).forEach(function (id) { items.push({ id: Number(id), quantity: counts[id] }); });
      } else {
        items.push({ id: state.single, quantity: 1 });
      }
      atc.disabled = true;
      var prev = atc.textContent;
      var failMsg = '';
      atc.textContent = atc.dataset.adding || 'adding\u2026';
      postJson(items).then(function (r) {
        if (r.ok) return r.json();
        // JSON rejected — keep its error but try the form post once before giving up
        return r.json().catch(function () { return {}; }).then(function (jsonBody) {
          return postForm(items).then(function (r2) {
            if (r2.ok) return r2.json();
            return r2.json().catch(function () { return {}; }).then(function (formBody) {
              var msg = (jsonBody && (jsonBody.description || jsonBody.message)) || (formBody && (formBody.description || formBody.message)) || ('HTTP ' + r.status);
              throw new Error(msg);
            });
          });
        });
      }).then(function () {
        refreshCartCount();
        try { openCartDrawer(); } catch (e) { if (window.console) console.error('[soothefy] drawer open failed:', e); }
      }).catch(function (err) {
        failMsg = (err && err.message) || 'network error';
        window.__sfAtcError = failMsg;
        if (window.console) console.error('[soothefy] add to cart failed:', failMsg);
      }).finally(function () {
        atc.disabled = false;
        if (failMsg) {
          atc.textContent = atc.dataset.error || 'could not add \u00b7 please try again';
          var offer = $('[data-sf-offerline]', section);
          if (offer) {
            var prevOffer = offer.textContent;
            offer.textContent = failMsg;
            setTimeout(function () { offer.textContent = prevOffer; }, 6000);
          }
          setTimeout(function () { atc.textContent = prev; }, 2600);
        } else {
          atc.textContent = prev;
        }
      });
    });

    function openCartDrawer() {
      var drawer = document.querySelector('sf-cart-drawer');
      if (drawer && typeof drawer.refreshAndOpen === 'function') { drawer.refreshAndOpen(); return; }
      if (drawer) {
        drawer.classList.add('is-open');
        document.body.classList.add('sfcd-lock');
        return;
      }
      refreshCartCount();
    }

    /* Sticky bar — hidden while the buy box or the footer is on screen */
    var sticky = $('[data-sf-sticky]', section);
    if (sticky) {
      var onScroll = function () {
        var r = section.getBoundingClientRect();
        var vh = window.innerHeight || 0;
        var buyVisible = r.top < vh * 0.85 && r.bottom > vh * 0.2;
        var foot = document.querySelector('.sf-footer');
        var footVisible = foot ? foot.getBoundingClientRect().top < vh - 30 : false;
        sticky.classList.toggle('is-on', window.scrollY > 700 && !buyVisible && !footVisible);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

    render();
    showImg(0);
    applyColorFilter();
  }

  /* ---------- Modes toggle ---------- */
  function initModes(section) {
    if (!section || section.dataset.sfInit) return;
    section.dataset.sfInit = '1';
    $$('[data-sf-mode]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var m = btn.dataset.sfMode;
        $$('[data-sf-mode]', section).forEach(function (b) {
          b.classList.toggle('is-cold', b.dataset.sfMode === 'cold' && m === 'cold');
          b.classList.toggle('is-warm', b.dataset.sfMode === 'warm' && m === 'warm');
        });
        $$('[data-sf-mode-panel]', section).forEach(function (p) {
          p.classList.toggle('is-active', p.dataset.sfModePanel === m);
        });
      });
    });
  }

  /* ---------- Init ---------- */
  function initAll(root) {
    initHeader(root || document);
    $$('[data-sf-buybox]').forEach(initBuyBox);
    $$('[data-sf-modes]').forEach(initModes);
    checkVideos();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    refreshCartCount();
    window.addEventListener('scroll', checkVideos, { passive: true });
    window.addEventListener('resize', checkVideos, { passive: true });
    if (vidTimer) clearInterval(vidTimer);
    vidTimer = setInterval(checkVideos, 1000);
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); checkVideos(); });
})();
